import { pluralRu } from '@wit-support/ui';
const WORDS = {
    day: {
        step: 'day',
        fem: false,
        title: 'День',
        titlePl: 'Дни',
        one: 'день',
        forms: ['день', 'дня', 'дней'],
        accForms: ['день', 'дня', 'дней'],
        ofForms: ['дня', 'дней', 'дней'],
        gen: 'дня',
        genPl: 'дней',
        thisGen: 'этого дня',
        thisAcc: 'этот день',
        byPl: 'по дням',
        every: 'каждый день',
    },
    week: {
        step: 'week',
        fem: true,
        title: 'Неделя',
        titlePl: 'Недели',
        one: 'неделя',
        forms: ['неделя', 'недели', 'недель'],
        accForms: ['неделю', 'недели', 'недель'],
        ofForms: ['недели', 'недель', 'недель'],
        gen: 'недели',
        genPl: 'недель',
        thisGen: 'этой недели',
        thisAcc: 'эту неделю',
        byPl: 'по неделям',
        every: 'каждую неделю',
    },
    month: {
        step: 'month',
        fem: false,
        title: 'Месяц',
        titlePl: 'Месяцы',
        one: 'месяц',
        forms: ['месяц', 'месяца', 'месяцев'],
        accForms: ['месяц', 'месяца', 'месяцев'],
        ofForms: ['месяца', 'месяцев', 'месяцев'],
        gen: 'месяца',
        genPl: 'месяцев',
        thisGen: 'этого месяца',
        thisAcc: 'этот месяц',
        byPl: 'по месяцам',
        every: 'каждый месяц',
    },
};
export function stepWords(step) {
    return WORDS[step];
}
/** «3 недели», «1 день». */
export const countWord = (w, n) => `${n} ${pluralRu(n, w.forms)}`;
/** «на 3 недели», «на 1 неделю» — без предлога. */
export const countAcc = (w, n) => `${n} ${pluralRu(n, w.accForms)}`;
/** «из 1 недели», «из 5 дней» — без предлога. */
export const countOf = (w, n) => `${n} ${pluralRu(n, w.ofForms)}`;
/** Глагол по роду шага: `v(w, 'ушла', 'ушёл')`. */
export const v = (w, fem, masc) => (w.fem ? fem : masc);
/**
 * Глагол при числе корзин: «1 / 21 неделя переходила», «21 день переходил»,
 * «2 недели / 5 дней переходили» — число и род берутся вместе через `pluralRu`,
 * а не `n === 1` (тогда «21 неделя переходили»).
 */
export const vn = (w, n, fem, masc, plural) => pluralRu(n, [v(w, fem, masc), plural, plural]);
//# sourceMappingURL=step-words.js.map